/* @flow */
import React from 'react';

import './styles/Toast.scss';

class Toast extends React.Component {
  render() {
    return (
      <div className="Toast">
        <div className="Toast-contents">
          {this.props.children}
        </div>
      </div>
    );
  }
}

export default Toast;



// WEBPACK FOOTER //
// ./src/components/Toast.jsx